import axiosInstance from '../api/axiosInstance';

const ENDPOINTS = {
  GET_NOTIFICATIONS: '/NotificationLists',
  SEND_NOTIFICATION: '/SendNotificationNeigboorhood',
};

export const getNotifications = async () => {
  const response = await axiosInstance.get(ENDPOINTS.GET_NOTIFICATIONS);
  return response.data;
};

// Send notification to neighborhoods
// Parameters (FormData):
// - Mahalleler: string (comma-separated neighborhood names)
// - Mesaj: string
// - Tip: string ('Tümü' or 'Mahalle')
// - image: File (optional)
// 
export const sendNotification = async (formData) => {
  const response = await axiosInstance.post(ENDPOINTS.SEND_NOTIFICATION, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};
